import { areasOfExpertiseFilter } from './scripts/areasOfExpertise/areasOfExpertiseFilter'
import * as styles from './styles/index.scss'
import { globals } from '@/src/globals'
import { blogListShowMore } from './scripts/blogList/blogListShowMore'
import { contentListHeightManager } from './scripts/contentList/contentListHeightManager'
import { timelineCarousel } from './scripts/timelineAlt/timelineCarousel'
import { formFiles } from './scripts/contactForm/formFiles'
import { freePositionsFilter } from './scripts/freePositions/freePositionsFilter'
import { topBannerScoller } from './scripts/topBanner/topBannerScroll'
import { formAfterSubmit } from './scripts/contactForm/formAfterSumbit'
import { axios_ecoMailSubscribeFooter } from './scripts/ecoMail/axios_ecoMailSubscribeFooter'
import { axios_ecoMailSubscribeHeader } from './scripts/ecoMail/axios_ecoMailSubscribeHeader'
import { achievementsCounter } from './scripts/achievements/achievementsCounter'
import { blockAnimator } from './scripts/blockAnimator'
import { topSliderScoller } from './scripts/topSlider/topSliderScroll'
import { menuImageManager } from './scripts/menu/menuImageManager'
import { buttonManager } from './scripts/button'
import { menuPhoneSubmenuControl } from './scripts/menu/menuPhoneSubmenuControl'
import { menuColorManager } from './scripts/menu/menuColorManager'
import { menuFixer } from './scripts/menu/menuFixer'
import { menuOverlayResizer } from './scripts/menu/menuOverlayResizer'
import { formControls } from './scripts/contactForm/formControls'
import { menuControl } from './scripts/menu/menuControl'
import { masonryQuotes } from './scripts/masonryQuotes'
import { menuDynamicScrollColor } from './scripts/menu/menuDynamicScrollColor'
import { topSliderControl } from './scripts/topSlider/topSliderControl'
import { testimonialsCarousel } from './scripts/testimonialsCarousel'
import { achievementsCarousel } from './scripts/achievements/achievementsCarousel'
import { topBannerControl } from './scripts/topBanner/topBannerControl'
import { smallTilesDynamicHeight, smallTilesShowAll } from './scripts/smallTiles/smallTilesShowAll'
import { mediumTilesDynamicHeight, mediumTilesShowAll } from './scripts/mediumTiles/mediumTilesShowAll'
import { bigTilesParalax } from './scripts/bigTiles/bigTilesParalax'
import { timelineHorizontalScroll } from './scripts/timeline/timelineHorizontalScroll'
import { employeePhoneShowMore } from './scripts/employees/employeeePhoneShowMore'
import { referencesListFilter } from './scripts/referencesList/referencesListFilter'
import { referencesListShowMore } from './scripts/referencesList/referencesListShowMore'
import { masonryElectroReferences } from './scripts/electroReferenceList/masonryElectroReferences'
import { formAutoFillPosition } from './scripts/contactForm/formAutoFillPosition'
import { formAutoFillSpecialTitle } from './scripts/contactForm/formAutoFillSpecialTitle'
import { electroReferenceCategoryListFilter } from './scripts/electroReferenceCategoryList/electroReferenceCategoryListFilter'
import { electroReferencesShowMoreManager } from './scripts/electroReferenceList/electroReferencesShowMoreManager'

// Main file
const ksystem = (input: any): void => {
  const processedStyles = styles

  globals.externalInput = input

  // Menu
  menuControl()
  menuOverlayResizer()
  menuFixer()
  menuColorManager()
  menuImageManager()
  menuPhoneSubmenuControl()
  menuDynamicScrollColor()

  // Elements
  buttonManager()

  // Generic animations
  blockAnimator()

  // Components
  masonryQuotes()
  formControls()
  formFiles()
  formAfterSubmit()
  formAutoFillPosition()
  formAutoFillSpecialTitle()
  testimonialsCarousel()
  topSliderScoller()
  topSliderControl()
  topBannerScoller()
  topBannerControl()
  achievementsCarousel()
  achievementsCounter()
  smallTilesShowAll()
  smallTilesDynamicHeight()
  mediumTilesShowAll()
  mediumTilesDynamicHeight()
  bigTilesParalax()
  timelineHorizontalScroll()
  timelineCarousel()
  freePositionsFilter()
  areasOfExpertiseFilter()
  employeePhoneShowMore()
  referencesListFilter()
  referencesListShowMore()
  contentListHeightManager()
  blogListShowMore()
  masonryElectroReferences()
  electroReferenceCategoryListFilter()
  electroReferencesShowMoreManager()

  // AXIOS calls
  axios_ecoMailSubscribeHeader()
  axios_ecoMailSubscribeFooter()
}

export default ksystem
